import classNames from 'classnames';
import React from 'react';

import { Tag } from '@eika/tag';

type Props = {
    className?: string;
    tags?: ReturnType<typeof Tag>[] | ReturnType<typeof Tag>;
};

const Tags: React.FC<Props> = ({ className, tags }) =>
    tags ? <span className={classNames(className, 'sgw-radio-option__labels')}>{tags}</span> : <></>;

export default Tags;
